import { Injectable } from '@angular/core';
import { Team } from '../models/new/team';

@Injectable({
	providedIn: 'root'
})
export class TeamMapper {
	constructor() {}

	toTeam(team: any) {
		return new Team({
			id: team.id,
			name: team.name
		});
	}
}
